// tslint:disable:max-line-length

import React from 'react';

export class Chevron extends React.Component<any, any> {
  render() {
    const props = {
      onClick: this.props.onClick,
      className: this.props.className,
      width: this.props.width ? `${this.props.width}px` : undefined,
      height: this.props.height ? `${this.props.height}px` : undefined,
    };
    switch (this.props.direction) {
      case 'left':
        return (
          <svg
            onClick={this.props.onClick}
            className={this.props.className}
            width='20px'
            height='20px'
            viewBox='0 0 511.949 511.949'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g>
              <g stroke='null' id='svg_1'>
                <g stroke='null' id='svg_2'>
                  <path
                    transform='rotate(180 255.97460937499997,255.97509765625003) '
                    id='svg_3'
                    fill='#FFFFFF'
                    d='m386.235,248.308l-245.333,-245.333c-4.267,-4.053 -10.987,-3.947 -15.04,0.213c-3.947,4.16 -3.947,10.667 0,14.827l237.76,237.76l-237.76,237.867c-4.267,4.053 -4.373,10.88 -0.213,15.04c4.053,4.267 10.88,4.373 15.04,0.213c0.107,-0.107 0.213,-0.213 0.213,-0.213l245.333,-245.333c4.16,-4.161 4.16,-10.881 0,-15.041z'
                  />
                </g>
              </g>
            </g>
          </svg>
        );
      case 'down':
        return (
          <svg {...props} viewBox='0 0 552 295' version='1.1' xmlns='http://www.w3.org/2000/svg'>
            <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
              <g id='chevron-down-2' transform='translate(-44.000000, -189.000000)'>
                <g id='icomoon-ignore' />
                <path
                  d='M557.376,195.488 C566.08,186.912 580.064,186.912 588.704,195.488 C597.344,204.064 597.376,217.92 588.704,226.496 L335.648,477.056 C327.008,485.632 313.024,485.632 304.32,477.056 L51.264,226.496 C42.624,217.92 42.624,204.064 51.264,195.488 C59.936,186.912 73.952,186.912 82.592,195.488 L320,424 L557.376,195.488 L557.376,195.488 Z'
                  id='Shape'
                  fill='#fff'
                />
              </g>
            </g>
          </svg>
        );
      case 'up':
        return (
          <svg {...props} viewBox='0 0 552 295' xmlns='http://www.w3.org/2000/svg'>
            <g>
              <g transform='rotate(180 275.989990234375,147.2719879150391) ' fill='none' id='Page-1'>
                <g id='chevron-down-2'>
                  <g id='icomoon-ignore' />
                  <path
                    fill='#fff'
                    id='Shape'
                    d='m513.376,6.488c8.704,-8.576 22.688,-8.576 31.328,0c8.64,8.576 8.672,22.432 0,31.008l-253.056,250.56c-8.64,8.576 -22.624,8.576 -31.328,0l-253.056,-250.56c-8.64,-8.576 -8.64,-22.432 0,-31.008c8.672,-8.576 22.688,-8.576 31.328,0l237.408,228.512l237.376,-228.512l0,0z'
                  />
                </g>
              </g>
            </g>
          </svg>
        );
      default:
        return (
          <svg
            onClick={this.props.onClick}
            className={this.props.className}
            xmlns='http://www.w3.org/2000/svg'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 511.949 511.949'
            width='20px'
            height='20px'
          >
            <g>
              <g>
                <path
                  d='M386.235,248.308L140.902,2.975c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76    l-237.76,237.867c-4.267,4.053-4.373,10.88-0.213,15.04c4.053,4.267,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213    l245.333-245.333C390.395,259.188,390.395,252.468,386.235,248.308z'
                  fill='#FFFFFF'
                />
              </g>
            </g>
          </svg>
        );
    }
  }
}
